<template>
    <v-flex xs12 v-if="(content && content.body) || content.canEdit || isHomePage">
        <v-card class="panelBlock">
            <v-expansion-panel :class="isHomePage ? 'txhub-section-home' : 'txhub-section'">
                <v-expansion-panel-content data-qe-id="transaction-hub_title">
                    <div slot="header">
                        <h2>{{communityCommonConstant.transactionHub.TITLE}}</h2>
                    </div>
                    <v-flex
                        xs12
                        ma-2
                        class="txhub"
                        v-if="content && content.body">
                        <v-card class="txhub__card">
                            <v-flex>
                                <v-flex tag="h2" data-qe-id="transaction-hub_card_title">
                                    {{cardTitle}}
                                    <edit-transaction-hub :content="content" v-if="content.canEdit" class="txhub__edit-button"></edit-transaction-hub>
                                    <v-flex data-qe-id="transaction-hub_card_description" class="txhub__card--card_description">
                                      {{communityCommonConstant.transactionHub.CARD_DESCRIPTION}}
                                    </v-flex>
                                </v-flex>
                            </v-flex>
                            <v-card-text class="txhub__message-text"
                                data-qe-id="transaction-hub_content-body"
                                @click="showConfirmationDialog"
                                v-html="transactionHubContentBody">
                            </v-card-text>
                            <v-flex text-xs-right v-if="showMoreBtn">
                                <v-btn @click="showMore=true"
                                    data-qe-id="transaction-hub_read-more_btn"
                                    flat
                                    class="primary_btn transparent small">
                                    {{communityCommonConstant.SHOW_MORE_BUTTON}}
                                </v-btn>
                            </v-flex>
                        </v-card>
                    </v-flex>
                    <v-dialog width="630" v-model="showMore">
                        <v-card>
                            <v-flex class="txhub-dialog">
                                <v-layout
                                    row
                                    wrap
                                    absolute
                                    class="txhub-dialog__cont">
                                    <v-flex class="xs12">
                                        <h2>{{communityCommonConstant.transactionHub.TITLE}}</h2>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex>
                                <v-card-text class="txhub-dialog__message-text txhub-dialog__message-desc-border"
                                    data-qe-id="content_body_text"
                                    v-html="content.body" @click="showConfirmationDialog">
                                </v-card-text>
                                <v-btn @click="showMore=false"
                                    data-qe-id="close_dialog_btn"
                                    flat
                                    class="txhub-dialog__btn-align">
                                    {{communityCommonConstant.CLOSE_BUTTON}}
                                </v-btn>
                            </v-flex>
                        </v-card>
                    </v-dialog>
                    <v-layout v-if="!(content && content.body) && content.canEdit" class="txhub txhub__new">
                        <edit-transaction-hub :content="content"></edit-transaction-hub>
                    </v-layout>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-card>
        <transaction-hub-dialog
            v-model="openConfirmationDialog"
            v-if="openConfirmationDialog">
        </transaction-hub-dialog>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { communityCommonConstant, showTransactionHubPopup } from "../communityCommon.constant";
    import { storeAction } from "@/store/storeActions.constant";
    import { storeGetters } from "@/store/storeGetters.constant";
    import EditTransactionHub from "./EditTransactionHub";
    import TransactionHubDialog from "./TransactionHubDialog";
    import { routerNames } from "../../appCommon.constants";

    export default {
        name: "TransactionHub",
        components: {
            EditTransactionHub,
            TransactionHubDialog,
        },
        created() {
            this.getTransactionHubContent();
            this.$watch(
                () => this.$store.getters[storeGetters.communityIdPromise],
                () => this.getTransactionHubContent(),
            );
        },
        data: () => {
            return {
                communityCommonConstant,
                showMore: false,
                openConfirmationDialog: false,
                routerNames,
            };
        },
        methods: {
            ...mapActions({
                getTransactionHubContent: `chapter/${storeAction.getTransactionHubContent}`,
            }),
            showConfirmationDialog($event) {
                this.openConfirmationDialog = showTransactionHubPopup($event, this.isMobileAppBrowser);
            },

        },
        computed: {
            ...mapGetters({
                content: `chapter/${storeGetters.transactionHubContent}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            cardTitle() {
                return `${communityCommonConstant.transactionHub.CARD_TITLE}`;
            },
            transactionHubContentBody() {
                const dots = "...";
                return this.content && this.content.body && (
                        this.content.body.length >
                        communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH
                    ) ?
                    this.content.body.substring(
                        0,
                        communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH,
                    ) + dots :
                    this.content.body;
            },
            showMoreBtn() {
                return this.content && this.content.body && (
                    this.content.body.length >
                    communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH
                );
            },
            isHomePage() {
              return this.$route.name === this.routerNames.HOME;
          },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/_responsive.scss";

    .txhub-dialog {
        &__message-text {
            font-weight: lighter;
            color: $ypo-duskblue;
            text-align: left;
            text-overflow: ellipsis;
            overflow: hidden;
            padding-top: 8px;
            padding-left: 25px;
            background-color: $white;
            word-wrap: break-word;
            font-size: 14px;
        }

        &__btn-align {
            margin-left: 507px;
            color: $ypo-cta;
            font-weight: bold;
            margin-right: 0;
            padding: 0;
          @include breakpointMin(xs) {
            margin-left: 250px;
          }
          @include breakpointMin(sm) {
            margin-left: 507px;
          }
        }

        &__message-desc-border {
            border-bottom: 1px solid $ypo-duskblue;
        }
    }

    .txhub-dialog {
        position: relative;
        background: $ypo-dark-background-gray;
        min-height: 150px;

        h2 {
            color: $white;
            margin: 50px 0 0 20px;
            font-size: 31px;
            font-weight: lighter;
        }

        &__cont {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            text-align: center;
        }
    }

    .txhub {
        border: 1px solid $ypo-medium-gray;
        border-radius: 4px;

        &__message-text {
            font-size: 12px;
            line-height: 20px;
            color: $ypo_blue;
            padding: 10px 15px 5px 15px;
            word-wrap: break-word;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        &__edit-button {
            position: absolute;
            top: 0;
            right: 0;
        }

        &__new {
            text-align: center;
            padding: 10px 20px;
        }

        &__card {
            border-radius: 4px;
            box-shadow: none;
            padding: 0;
            margin: 0;

          &--card_description{
            font-size: 12px;
            line-height: 20px;
            color: $ypo_blue;
            white-space: normal;
            font-weight: 500;
            text-decoration: none;
            a {
              text-decoration: none;
              color: black;
            }
          }
        }
    }
    .txhub-section-home {
      box-shadow: none;

      .v-icon {
        font-size: 19px;
      }

      p {
        padding: 0 20px;
        margin-top: 15px;
      }

      .v-expansion-panel__container {
        border-radius: 4px;
      }

      .v-expansion-panel__header {
        padding: 0;
        min-height: inherit;

        h2 {
          border-bottom: none;
          margin: 0;
          padding: 0;
        }
      }

      .v-list__tile__title {
        color: $ypo-blue-dark-background;
        font-family: Raleway, sans-serif;
        font-size: 20px;
        letter-spacing: 0.17px;
        line-height: 29px;
        margin-bottom: 5px;
      }

      .v-list__tile__sub-title {
        color: $black;
        font-family: Raleway, sans-serif;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.46px;
        line-height: 16px;
      }
    }
</style>
